
const RunEnum = Object.freeze({
  // 測試機
  Debug: 0,
  // 正式機
  Release: 1,
  // 安新測試機
  DebugForAnn: 2,
});

var hostList = {};

// Debug: 連測試站 , Release:連正式站
const runType = RunEnum.Release;
hostList["runType"] = runType;

hostList["version"] = "1.3.83";

if (runType == RunEnum.Debug) {
  // 測試站
  hostList["PRIVATE_HOST"] = "https://anshinescrow-dev.januarytc.com";
  hostList["WEB_HOST"] = "https://anshinescrow-dev.januarytc.com";

} else if (runType == RunEnum.DebugForAnn) {
  // 安新測試站
  hostList["PRIVATE_HOST"] = "http://10.10.242.39";
  hostList["WEB_HOST"] = "http://10.10.242.39";
} else {
  // 正式站
  hostList["PRIVATE_HOST"] = "http://anshinescrow-lb.januarytc.com";
  hostList["WEB_HOST"] = "https://www.anshinescrow.com";
}

// 檢查是否為測試機
hostList.checkHost = function() {
  if (hostList["PRIVATE_HOST"]?.indexOf("dev") != -1 ||
    hostList["PRIVATE_HOST"]?.indexOf("10.10.242.39") != -1 ){
    // 測試機
    return 0
  } else {
    return 1
  }
};

export default hostList;
